import {
  sanitizeApellidoPersona,
  sanitizeNombrePersona,
  toPlainLowercase,
} from '../../../shared/helpers/nombre-texto.helper';
import {
  AgregarPersonaDatosBasicos,
  AgregarPersonaPasoConfirmacion,
} from '../agregar-persona-form.interface';
import { CreateUserRequest } from '../../../shared/interfaces/user.interface';
import { SessionUser } from '../../../shared/interfaces/session-user.interface';
import { UserListItem } from '../../../shared/interfaces/user.interface';

const ID_LIDER_NINGUNO = 'sin lider';
const ID_LIDER_EVADIR = 'evadir';

function slugPart(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, '');
}

/** mailAccess estilo Mayorap2: nombre+nombre2+apellido@iglesia.com */
export function buildMailAccess(
  datos: AgregarPersonaDatosBasicos,
  iglesia: string,
): string {
  const local = `${slugPart(datos.nombre)}${slugPart(datos.nombre2 ?? '')}${slugPart(datos.apellido)}`;
  return `${local}@${slugPart(iglesia)}.com`;
}

function nombreCompleto(nombre: string, apellido: string): string {
  return `${nombre} ${apellido}`.trim();
}

export function resolveMiLider(
  idLider: string,
  session: SessionUser | null,
  lideres: UserListItem[],
  nombrePropio = '',
): string {
  if (idLider === ID_LIDER_EVADIR) {
    return ID_LIDER_EVADIR;
  }
  if (idLider === ID_LIDER_NINGUNO || !idLider) {
    return ID_LIDER_NINGUNO;
  }
  const found = lideres.find((lider) => lider.id === idLider);
  if (found) {
    return nombreCompleto(found.nombre, found.apellido);
  }
  if (idLider === session?._id) {
    const propio = nombrePropio.trim();
    return propio || ID_LIDER_NINGUNO;
  }
  return ID_LIDER_NINGUNO;
}

/**
 * Arma el body de POST /api/users.
 * El schema del back es strict: no envía bautizado / nivelPersonal.
 * descripcion solo va en el alta, con el mensaje de sistema.
 */
export function buildCreateUserPayload(input: {
  datos: AgregarPersonaDatosBasicos;
  confirmacion: AgregarPersonaPasoConfirmacion;
  session: SessionUser;
  descripcion?: CreateUserRequest['descripcion'];
}): CreateUserRequest {
  const { datos, confirmacion, session } = input;
  const mailAccess = buildMailAccess(datos, session.iglesia);
  const contactEmail = confirmacion.email.trim();
  const email =
    contactEmail || mailAccess.replace('@', `+${Date.now()}@`);

  return {
    nombre: sanitizeNombrePersona(datos.nombre),
    apellido: sanitizeApellidoPersona(datos.apellido).trim(),
    nombre2: sanitizeNombrePersona(datos.nombre2 ?? ''),
    email,
    mailAccess,
    sexo: datos.sexo,
    nacimiento: datos.nacimiento.toISOString(),
    prefijo: datos.prefijo,
    celular: datos.celular?.trim() || undefined,
    direccion: toPlainLowercase(confirmacion.direccion ?? '') || undefined,
    ciudad: confirmacion.ciudad || undefined,
    idLider: confirmacion.idLider || ID_LIDER_NINGUNO,
    miLider: confirmacion.miLider || ID_LIDER_NINGUNO,
    ministerio: confirmacion.ministerio || 'ninguno',
    access: 2,
    admin: confirmacion.admin,
    lider: confirmacion.lider,
    contador: confirmacion.contador,
    ...(input.descripcion ? { descripcion: input.descripcion } : {}),
  };
}